export function getComparisonEntry(originalEntry, comparisonEntries) {
    if (!comparisonEntries)
        return null;
    const result = comparisonEntries.find((entry) => entry.key === originalEntry.key);
    if (!result) {
        return comparisonEntries.find((entry) => entry.title === originalEntry.title);
    }
    return result;
}
